import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Deposit from '../ControlPanel/Common/DepositOrder/Deposit';
import AnimButton from '../Button/AnimButton';
import {getSelectedTab, handleMobileDraw, handlePriceAndSummaryMobileView, handleShowPhotoModal, setIsShowEditIconSection} from '../../action/index.js'
import { handleCommonModal, handleProductModal } from '../../action/quote_order/leadcustomer.action.js';
import OrderNow from '../ControlPanel/Common/OrderNow.js';
import { CheckCaptureModalImage } from '../../action/extra_options/orderExtras.action.js';
import { handleSaveLatter, handleSavePublicQuote } from '../../action/quote_order/quote.action.js';
import { downloadOnClick, prepareTwoDMapData } from '../../action/2d_mapping/twoDMap.action.js';
import { const_var } from '../../redux/reducers/reducer.js';
import Total from '../ControlPanel/Common/DepositOrder/Total.js';
import TotalDiscount from '../ControlPanel/Common/DepositOrder/TotalDiscount.js';
import GrandTotal from '../ControlPanel/Common/DepositOrder/GrandTotal.js';

const MobileFooter = () => {

    const state = useSelector((state) => state.reducer);
    const dispatch = useDispatch();

    const showPriceDetails = () => {
        dispatch(handlePriceAndSummaryMobileView(0));
        const removea = document.querySelector("body");
        removea.classList.add("active-total-price");
    }

    const onSaveClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        //this.props.autoGeneratedPDF();
    };
    
    const onQuoteClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        dispatch(handleSaveLatter('open'));
    };

    const designBuilding = () => {
        dispatch(handleMobileDraw(true));
        dispatch(getSelectedTab(''))
        if(state.isShowPhotoModal) {
            dispatch(handleShowPhotoModal());
        }
        dispatch(setIsShowEditIconSection(false));
    }
    let showPriceDiv = (state.const_var.loginSession == true || state.const_var.isKLinkEnable == true || state.const_var.is_Edit == true || state.const_var.loginSession.isPublicEdit == true || state.const_var.hide_price_calculation == false ) == true ? true : false
    
    if(state.const_var.isKLinkEnable == true && state.const_var.hide_price_calculation == true){
        showPriceDiv = false
    }
    if(state.const_var.loginSession == false && state.const_var.checkmoreCustomizeFlag == true){
        showPriceDiv = false
    }
    if(state.selectedTabstate == "statechange" || state.selectedTabstate == "buildstyle" || state.selectedTabstate == "loginstyletab"){
        showPriceDiv = false
    }
    if(state.const_var.post_data == undefined){
        showPriceDiv = false
    }

    let orderNowInitialCheck = state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false && state.const_var.stateData && state.const_var.stateData.hide_price_calculation == 0 &&  (state.const_var.crmSetting.is_show_cta == true || state.const_var.crmSetting.is_show_cta == undefined);

    let orderNowOtherCheck = state.const_var.crmSetting.is_module_name === "inventory" || (state.const_var.isPublicEdit==true && state.const_var.crmSetting.is_quote_Edit==true || state.const_var.isPublicEdit==true)

    let manufacturer_discount =
        state.const_var.post_data.building != undefined &&
        state.const_var.post_data.building.discount_amount != undefined &&
        state.const_var.post_data.building.discount_amount != 0;

    return (
        !state.isMobileDraw ?
            <div className='mobile-footer'>
                <div className='building-information' onClick={showPriceDetails}>
                    <div className='building-type'>
                        {state.params.building_type_name}{" "}
                        {state.params.p_w}x{state.params.p_d}x{state.params.p_h} 
                    </div>
                    <div className={showPriceDiv == true ? 'building-price':'building-price d-none'}>
                        {/* <span> 
                           - <Total />
                         </span> */}
                        {
                            state.const_var.loginSession == true 
                            ?
                                (state.const_var.stateData != undefined && state.const_var.stateData.loggedin_price_type != undefined &&  state.const_var.stateData.loggedin_price_type == 1)
                                ? 
                                
                                // <label class="nav-info-name">Grand Total : 
                                <span className="main-price">
                                    <GrandTotal/>     
                                </span>
                                // </label>
                                :
                                // <label class="nav-info-name">Sub Total : 
                                    <span className="main-price">
                                    {manufacturer_discount ? <del className="line-color-red"><Total/></del> : <span className="color-dark"><Total/></span>}
                                    {manufacturer_discount ? <span className="color-dark ml-1"><TotalDiscount /></span> : null} 
                                    </span>
                                // </label>
                            :
                                (state.const_var.stateData != undefined && state.const_var.stateData.visitors_price_type != undefined && state.const_var.stateData.visitors_price_type == 1) 
                                ? 
                                // <label class="nav-info-name">Grand Total : 
                                    <span className="main-price">
                                    <GrandTotal/>      
                                    </span>
                                // </label>
                                :
                                // <label class="nav-info-name">Sub Total : 
                                <span className="main-price">
                                    {manufacturer_discount ? <del className="line-color-red"><Total/></del> : <span className="color-dark"><Total/></span>}
                                    {manufacturer_discount ? <span className="color-dark ml-1"><TotalDiscount /></span> : null} 
                                </span>
                                // </label>
                        }
                        <i className='icon-arrow-down-ico'></i>
                    </div>
                </div>
                <div className='building-information' data-tut="Designyourbuilding">
                    <AnimButton className='design-container btn btn-primary' isAnimation={false} event={() => designBuilding()}>
                        <i className='icon icon-draw-ico'></i>
                        <span>DESIGN BUILDING</span>
                    </AnimButton>
                </div>
            </div>
            :
            <div className='mobile-footer order-wrapper'>
                <div className='building-information' onClick={showPriceDetails}>
                    <div className='building-type'>
                        {state.params.building_type_name}{" "}
                        {state.params.p_w}x{state.params.p_d}x{state.params.p_h}
                    </div>
                    <div className={showPriceDiv == true ? 'building-price' :'building-price d-none'}>
                        {/* <span>
                            <Total />
                         </span> */}
                        {
                            state.const_var.loginSession == true 
                            ?
                                (state.const_var.stateData != undefined && state.const_var.stateData.loggedin_price_type != undefined &&  state.const_var.stateData.loggedin_price_type == 1)
                                ? 
                                
                                // <label class="nav-info-name">Grand Total : 
                                <span className="main-price">
                                    <GrandTotal/>     
                                </span>
                                // </label>
                                :
                                // <label class="nav-info-name">Sub Total : 
                                    <span className="main-price">
                                    {manufacturer_discount ? <del className="line-color-red"><Total/></del> : <span className="color-dark"><Total/></span>}
                                    {manufacturer_discount ? <span className="color-dark ml-1"><TotalDiscount /></span> : null} 
                                    </span>
                                // </label>
                            :
                                (state.const_var.stateData != undefined && state.const_var.stateData.visitors_price_type != undefined && state.const_var.stateData.visitors_price_type == 1) 
                                ? 
                                // <label class="nav-info-name">Grand Total : 
                                    <span className="main-price">
                                    <GrandTotal/>      
                                    </span>
                                // </label>
                                :
                                // <label class="nav-info-name">Sub Total : 
                                <span className="main-price">
                                    {manufacturer_discount ? <del className="line-color-red"><Total/></del> : <span className="color-dark"><Total/></span>}
                                    {manufacturer_discount ? <span className="color-dark ml-1"><TotalDiscount /></span> : null} 
                                </span>
                                // </label>
                        }
                        <i className='icon-arrow-down-ico'></i>
                    </div>
                </div>
                <div className={(const_var.crmSetting.is_show_cta == true || const_var.crmSetting.is_show_cta == undefined ? 'order-container' : "d-none") + ( orderNowInitialCheck && state.const_var.loginSession === false ? ' order-container-pl10':'')}>
                    <div data-tut="VieworSaveQuote" className={(state.selectedTabstate == "statechange" || state.selectedTabstate == "buildstyle" || state.selectedTabstate == "loginstyletab") ? 'd-none save-order' : 'save-order'}>
                        <div>
                        {  //for save button without login case
                            state.const_var.loginSession == false
                            ?
                            (
                                const_var.crmSetting.main_domain_url != 'metalcarportdepotllc.com'
                                ? 
                                    <>
                                        {(state.const_var.crmSetting.is_module_name == "inventory") ?
                                            <div>
                                                <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                                    id="save_update_inventory_automation"
                                                    onClick={(e) => dispatch(handleProductModal())}
                                                >
                                                    {const_var.crmSetting.main_domain_url == 'idealsteelbuildingsofca.com' ?
                                                        <span className='btn btn-primary mobile-btn-primary'>
                                                            <span className="text sales-login-text">
                                                                {(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}
                                                            </span>
                                                            {/* <span className="icon">
                                                                <i className="icon-double-arrow-ico"></i>
                                                            </span> */}
                                                        </span> 
                                                        :
                                                        <span className="icon icon-save"></span>
                                                    }
                                                </a>
                                            </div>
                                            :
                                            <>
                                            {(state.const_var.isPublicEdit != true) ?
                                                <div>
                                                    <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                                        id="save_update_orderquote_automation"
                                                        onClick={(state.const_var.crmSetting.form_action == "edit" &&
                                                            state.const_var.i_g_A_y.length > 0)
                                                            ?
                                                            (e) => {
                                                            dispatch(CheckCaptureModalImage('open'))
                                                            onSaveClick();
                                                            }
                                                            :
                                                            (state.const_var.loginSession == false)
                                                            ?
                                                            (e) => {
                                                                dispatch(handleSaveLatter('open'));
                                                                onSaveClick();
                                                            }
                                                            :
                                                            (e) => {
                                                                dispatch(handleCommonModal('lead_customer', 'save'))
                                                                onSaveClick();
                                                            }
                                                        }
                                                    >
                                                        {orderNowInitialCheck ? (
                                                            state.const_var.loginSession === false ? (
                                                                orderNowOtherCheck ? null : (
                                                                    <span className={`icon icon-save ${(state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com") ? ' highlighted' : ''}`}></span>
                                                                )
                                                            ) : null
                                                        ) : ( 
                                                            const_var.crmSetting.main_domain_url == 'idealsteelbuildingsofca.com' ?
                                                                <span className='btn btn-primary mobile-btn-primary'>
                                                                    <span className={`${state.const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && 'ideal-steel-no-caps'} text`}>
                                                                        {
                                                                            state.const_var.crmSetting.form_action == "edit"
                                                                                ?
                                                                                (state.const_var.crmSetting.is_module_name == "quote")
                                                                                ?
                                                                                "Update Quote"
                                                                                :
                                                                                "Update & Share"
                                                                                :
                                                                                (state.const_var.crmSetting.is_module_name == "quote")
                                                                            ?
                                                                                state.const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(state.const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : "Save & Share")
                                                                            :
                                                                                state.const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(state.const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!": "Save & Share")
                                                                        }
                                                                    </span>
                                                                    {/* <span className="icon">
                                                                        <i className="icon-double-arrow-ico"></i>
                                                                    </span> */}
                                                                </span>
                                                                :
                                                                <span className='btn btn-primary mobile-btn-primary'>
                                                                    <span className='text'>{(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : const_var.crmSetting.main_domain_url == "solidrockstructuresllc.com" ? "Current sales" : "Save")}</span>
                                                                    {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                                                </span>
                                                            )
                                                        }
                                                    </a>
                                                </div>
                                                :
                                                <div>
                                                    <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                                    id="save_update_orderquote_automation"
                                                    onClick={(e) => { dispatch(handleSavePublicQuote('open')); onSaveClick(); }}
                                                    >
                                                        {const_var.crmSetting.main_domain_url == 'idealsteelbuildingsofca.com' ?
                                                            <span className='btn btn-primary mobile-btn-primary'>
                                                                <span className='text'>Update & Share</span>
                                                                {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                                            </span>
                                                            :
                                                            <span className='btn btn-primary mobile-btn-primary'>
                                                                <span className='text'>{(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}</span>
                                                                {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                                            </span>
                                                        }
                                                    </a>
                                                </div>
                                            }
                                            </>
                                        }
                                    </>
                                :
                                    null
                            )
                            :
                            <>
                                {
                                (state.const_var.crmSetting.is_module_name == "inventory") ? 
                                    <div>
                                        <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                            id="save_update_inventory_automation"
                                            onClick={(e) => dispatch(handleProductModal())}
                                        >
                                        <span className='btn btn-primary mobile-btn-primary'>
                                            <span className='text'>{(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}</span>
                                            {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                        </span>
                                        </a>
                                    </div>
                                    :
                                    <>
                                    {(state.const_var.isPublicEdit != true) ?
                                        <div>
                                            <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                                id="save_update_orderquote_automation"
                                                onClick={(state.const_var.crmSetting.form_action == "edit" &&
                                                    state.const_var.i_g_A_y.length > 0)
                                                    ?
                                                    (e) => {
                                                        dispatch(CheckCaptureModalImage('open'))
                                                        onSaveClick();
                                                    }
                                                    :
                                                        (state.const_var.loginSession == false)
                                                    ?
                                                    (e) => {
                                                        onQuoteClick();
                                                        onSaveClick();
                                                    }
                                                    :
                                                    (e) => {
                                                        dispatch(handleCommonModal('lead_customer', 'save'))
                                                        onSaveClick();
                                                    }
                                                }
                                            >
                                            <span className='btn btn-primary mobile-btn-primary'>
                                                <span className="text">
                                                    {
                                                    state.const_var.crmSetting.form_action == "edit"
                                                        ?
                                                        (state.const_var.crmSetting.is_module_name == "quote")
                                                        ?
                                                        "Update"
                                                        :
                                                        "Update"
                                                        :
                                                        (state.const_var.crmSetting.is_module_name == "quote")
                                                    ?
                                                        (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")
                                                    :
                                                        (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")
                                                    }
                                                </span>
                                                {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                            </span>
                                            </a>
                                        </div>
                                        :
                                        <div>
                                            <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                                id="save_update_orderquote_automation"
                                                onClick={(e) => { dispatch(handleSavePublicQuote('open')); onSaveClick(); }}
                                                >
                                                    <span className="icon icon-save"></span>
                                            </a>
                                        </div>
                                    }
                                    </>
                                }
                            </>
                        }
                        </div>
                        <div>
                        {orderNowInitialCheck ?
                            <>
                                {state.const_var.loginSession === false ? (
                                orderNowOtherCheck ? (
                                    <></>
                                ) : (
                                <div className='header-order-btn-wrp'>
                                    <OrderNow
                                        title="Order now"
                                        i_g_A_y={state.const_var.i_g_A_y}
                                        order_now={state.const_var.crmSetting.order_now}
                                        is_quote_Edit={state.const_var.crmSetting.is_quote_Edit}
                                        form_action={state.const_var.crmSetting.form_action}
                                        is_loggedin={state.const_var.loginSession}
                                    />
                                </div>
                                )
                            ) : null}
                            </> : null}
                        </div>
                    </div>
                    
                </div>
            </div>
    )
}

export default MobileFooter